import { Link } from "react-router-dom";

export default function Species(props) {
    const classes = "inline-block px-4 py-2 border border-transparent text-base font-medium rounded-md text-white " + props.type.color + " shadow-md hover:bg-opacity-75 mr-5 ml-5 cursor-pointer mb-5";

    return (
        <Link to={props.type.url}>
            <button className={classes}>
                {props.type.text}
            </button>
        </Link>
    );
}
